import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { configureBorgeeTransport } from './client-core/transport';
import { createWebTransport } from './hosts/web/transport';
import { getDevUserId } from './lib/api';
import { LanguageProvider } from './i18n/provider';
import { createLanguageRuntime } from './i18n/runtime';
import { connectDocumentTitle } from './i18n/documentTitle';
import { connectServiceWorkerLanguage, registerServiceWorker } from './lib/serviceWorker';

const languageRuntime = createLanguageRuntime();
connectDocumentTitle(languageRuntime, 'user');

configureBorgeeTransport(
  createWebTransport({ getDevUserId, isDevelopment: import.meta.env.DEV }),
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LanguageProvider runtime={languageRuntime}>
      <App />
    </LanguageProvider>
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  connectServiceWorkerLanguage(languageRuntime);
  window.addEventListener('load', () => {
    void registerServiceWorker().catch(console.error);
  });
}
